module.exports = __webpack_public_path__ + "img/mg-weixin-weiweima-people.b0e2d989.png";